import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["messages"];
import React, { forwardRef } from 'react';
import { TextInput as InstUITextInput } from '@instructure/ui-text-input';
import { enhanceErrorMessages } from '../../util/enhanceErrorMessages';
/**
 * This is a wrapper around the InstUI `TextInput` component.
 *
 * Differences include:
 * - If the `messages` prop contains an error message, it will include an icon
 */
export var TextInput = forwardRef(function (_ref, ref) {
  var messages = _ref.messages,
    props = _objectWithoutProperties(_ref, _excluded);
  var messagesWithEnhancedErrors = enhanceErrorMessages(messages);
  return /*#__PURE__*/React.createElement(InstUITextInput, Object.assign({}, props, {
    ref: ref,
    messages: messagesWithEnhancedErrors
  }));
});
TextInput.displayName = 'TextInput';